import { Button } from '../ui/button';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

export const UpsellCard = ({ title, description, link, isDiscounted }) => {
    const isExternal = link.startsWith('http');
    const navigate = useNavigate({ from: '/' });

    return (
        <div className="rounded-2xl p-4 flex flex-col flex-wrap grow-0 gap-2 bg-neutral-50 text-neutral-950 border border-neutral-300 max-w-[220px] h-auto">
            <h4 className="font-semibold flex flex-col">
                {title}
                {isDiscounted === true && <span className="text-primary">(30% Fee Discount)</span>}
            </h4>
            <p className="text-sm text-neutral-700">{description}</p>

            {!isExternal && (
                <Button
                    variant="link"
                    className="self-start mt-2 py-1 flex justify-center items-center gap-2"
                >
                    <a>
                        Learn More <ChevronRight size={18} onClick={() => navigate({ to: link })} />
                    </a>
                </Button>
            )}

            {isExternal && (
                <Button
                    variant="link"
                    className="self-start mt-2 py-1 flex justify-start items-start"
                >
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex justify-center items-center gap-2 hover:underline"
                    >
                        Explore Programs <ChevronRight size={18} />
                    </a>
                </Button>
            )}
        </div>
    );
};
